<template>
  <div>
    <div class="box">
      <p class="title">招聘岗位：智能体研发工程师</p>
      <p class="part_title">一、岗位职责</p>
      <!-- <p class="title">在这里，你可以：</p> -->
      <!-- <div class="detail_desc">
        <p>1、利用具有竞争力的产品和商业模式为客户创造价值；</p>
        <p>2、利用公司搭建的平台积累优质人脉资源；</p>
        <p>3、在最具朝阳的科技医疗和科技养老的产业里施展你的才华；</p>
        <p>4、成为交易和谈判专家，沟通各种交易模式和商务方案，掌握谈判节奏。</p>
      </div>
      <p class="title">主要负责：</p> -->
      <div class="detail_desc">
        <p>
          1. 负责**AI 智能体（Agent）**整体架构设计、核心逻辑研发与工程化落地，包括规划、记忆、工具调用、反思、多轮协作等模块。
        </p>
        <p>
          2. 基于大模型（LLM）进行智能体能力开发，包括 Prompt 工程、Function Calling、RAG 增强、多智能体协作框架搭建。
        </p>
        <p>3. 设计与实现智能体工具生态，对接搜索、代码解释器、数据库、API 插件、外部系统等，提升工具调用稳定性与准确率。</p>
        <p>
          4. 负责智能体长上下文理解、任务拆解、多轮对话管理、记忆机制优化，提升复杂任务完成能力。
        </p>
        <p>
          5. 参与多智能体系统（Multi-Agent）设计，实现智能体之间协作、分工、调度与冲突解决。
        </p>
        <p>6. 对智能体进行效果评测、迭代优化，包括 hallucination 抑制、可靠性提升、执行成功率优化等。</p>
        <p>
          7. 与产品、算法、后端团队协同，将智能体能力落地到客服、办公助手、行业解决方案等场景。
        </p>
        <p>8. 跟踪前沿 Agent 技术（如 AutoGPT、GPTs、SOP-Agent、Reasoning 模型），沉淀技术方案与最佳实践。</p>
      </div>
      <p class="part_title">二、岗位要求</p>
      <div class="detail_desc">
        <p>1. 本科及以上学历，计算机、软件工程、人工智能等相关专业，2年及以上相关研发经验。</p>
        <p>
          2. 熟练掌握 Python/Java/Go 至少一种，具备扎实的后端开发、数据结构与算法基础。
        </p>
        <p>
          3. 熟悉主流大模型接口（OpenAI、文心一言、通义千问、Llama 等），有实际 LLM 应用开发经验。
        </p>
        <p>
          4. 理解智能体核心机制：规划、记忆、工具调用、反思、RAG、多轮对话管理，有相关项目经验优先。
        </p>
        <p>5. 了解常见 Agent 框架：LangChain、LlamaIndex、AutoGPT、MetaGPT、AgentScope 等优先。</p>
        <p>6. 有向量数据库（Milvus/Chroma/FAISS）、API 插件开发、函数调用落地经验者优先。</p>
        <p>7. 具备良好的系统设计能力，能独立完成模块设计、开发、测试与上线。</p>
        <p>8. 对 AI 前沿技术敏感，有较强问题排查与迭代优化能力，良好的团队协作与沟通能力。</p>
      </div>
      <!-- <p class="part_title">三、薪酬待遇</p>
      <div class="detail_desc">
        <p>
          1、我们提供有竞争力的薪资福利、提成方式和良好的发展平台，每个人都能获得非常好的发展；
        </p>
        <p>
          2、我们提供一流的工作氛围，与行业大佬携手同行，与优秀的团队一起成长，视野和格局能快速获得提升；
        </p>
        <p>
          3、我们期待您更优秀的同时，我们具有较强的培养员工的意愿，会为即将踏入社会大学的您量身定制大量培养计划。
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.box {
  font-size: 0.18rem;
  line-height: 0.36rem;

  background: #fff;
  color: #21252e;
  padding: 0;
  font-weight: 400;
  color: #21252e;
  font-family: "PingFang SC";
  font-style: normal;
  box-sizing: border-box;
  padding: 0 1.9rem;
}
/* @media screen and (max-width:1910px) {
    .box{
        padding: 0;
    }
} */
.title {
  font-weight: 800;
  color: #000;
  margin: 0.1rem 0;

  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 900;
  font-size: 0.18rem;
  line-height: 0.36rem;

  color: #21252e;
}
.part_title {
  background: #f7f7f7;
  color: #000;
  font-weight: 800;
  padding: 4px 6px;
  box-sizing: border-box;
  margin: 20px 0;

  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 900;
  font-size: 0.18rem;
  line-height: 0.36rem;

  color: #21252e;
}
.detail_desc {
  line-height: 0.36rem;
}
@media screen and (max-width: 1024px) {
  .box {
    padding: 0 20px;
  }
  .detail_desc {
    line-height: 0.5rem;
  }
}
</style>
